module.exports = __webpack_public_path__ + "img/Soma-Streatfood-logo.cb03ce76.jpg";